import { BOT_CONTENT_ACTION_TYPES } from "../../redux/allAction/botContentActions";

const initialState = {
  // Core data
  botContent: null,
  
  // UI states only
  loading: true,
  updating: false,
  alert: {
    show: false,
    type: "info",
    message: "",
  },
};

export const botContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOT_CONTENT_ACTION_TYPES.SET_BOT_CONTENT:
      return {
        ...state,
        botContent: typeof action.payload === 'function' 
          ? action.payload(state.botContent) 
          : action.payload
      };

    case BOT_CONTENT_ACTION_TYPES.SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case BOT_CONTENT_ACTION_TYPES.SET_UPDATING:
      return {
        ...state,
        updating: action.payload
      };

    case BOT_CONTENT_ACTION_TYPES.SET_ALERT:
      return {
        ...state,
        alert: action.payload
      };

    case BOT_CONTENT_ACTION_TYPES.RESET_BOT_CONTENT:
      return initialState;

    default:
      return state;
  }
};